import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaInputWrapper from './VaInputWrapper.vue'

export const VaInputWrapper = withConfigTransport(_VaInputWrapper)
